import { render } from "./footerHome.vue?vue&type=template&id=0ac85a14&scoped=true"
const script = {}

import "./footerHome.vue?vue&type=style&index=0&id=0ac85a14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac85a14"]])

export default __exports__